import { createApp } from 'Vue';
import Vueform from '@vueform/vueform';
import type { VueformConfig } from '@vueform/vueform';

export class ResponsiveAppMount {
    constructor(
        private mountDataId: string,
        private moduleSelector: string,
        private isInPopup: boolean,
        private App: any,
        private Config: VueformConfig
    ) {}

    public init(): void {
        if (!this.isInPopup) {
            this.renderInPage();
        } else {
            this.setPopupOpenEvent();
        }
    }

    private renderInPage(): void {
        this.mountVueApp(this.mountTarget());
        this.formContent()!.style.display = 'block';
    }

    private setPopupOpenEvent(): void {
        const button = document.querySelector<HTMLElement>(`${this.moduleSelector} .popup-open-button`);
        button!.addEventListener('click', () => {
            if (this.formContent() !== null) {
                this.renderInPopup();
            }
        });
    }

    private renderInPopup(): void {
        this.createPopup();
        this.setPopupContent();
        this.adjustBodyAndHeader('temporary');
        this.mountVueApp(`.form-popup ${this.mountTarget()}`);
        this.formPopup()?.classList.remove('hidden');
    }

    private createPopup(): void {
        const contentClass = this.moduleSelector.split('.').join(' ');
        const popup = document.createElement('div');
        popup.className = 'form-popup hidden';
        popup.innerHTML =
            '<button class="close-popup" aria-label="Close popup"></button>' +
            `<div class='content ${contentClass}'></div>`;
        document.body.appendChild(popup);
        this.setCloseButtonEvent();
    }

    private setPopupContent() {
        const popupContent = this.formPopup()!.querySelector<HTMLElement>('.content');
        popupContent!.innerHTML = this.formContent()!.outerHTML;
        this.formPopup()!.querySelector<HTMLElement>('.form-content')!.style.display = 'block';
    }

    private setCloseButtonEvent(): void {
        const closeButton = this.formPopup()!.querySelector<HTMLElement>('.close-popup');
        closeButton!.addEventListener('click', () => {
            this.formPopup()!.remove()
            this.adjustBodyAndHeader('default');
        });
    }

    private mountVueApp(targetContainer: string): void {
        createApp(this.App)
            .use(Vueform, this.Config)
            .mount(targetContainer);
    }

    private adjustBodyAndHeader(type: string): void {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        const body = document.body;
        const header = document.querySelector('header');
        if (type === 'temporary') {
            if (header && header.classList.contains('fixed')) {
                header.style.right = `${scrollbarWidth}px`;
            }
            body.style.paddingRight = `${scrollbarWidth}px`;
            body.style.overflowY = 'hidden';
        }

        if (type === 'default') {
            if (header && header.classList.contains('fixed')) {
                header.style.right = '0';
            }
            body.style.paddingRight = '0';
            body.style.overflowY = 'auto';
        }
    }

    private formContent(): HTMLElement|null {
        return document.querySelector<HTMLElement>(this.moduleSelector + ' .form-content');
    }

    private mountTarget(): string {
        return `[data-id='${this.mountDataId}']`;
    }

    private formPopup(): HTMLElement|null {
        return document.querySelector<HTMLElement>('.form-popup');
    }
}
